import {useLsValue} from '../../../../../hooks/use-ls-value';
import {GraphViewKind} from '../../../../../components/graph/interface';
import {LS_PREFIX} from '../../../../../providers/global-state';
import {GraphPresentation, GraphPresentationDetails} from './interface';
import {MaxPathLengthOptionResult} from './requests/use-query-result-max-length-options';

interface Props {
    queryId: number;
    selectedPresentation: GraphPresentation;
    selectedPresentationDetails: GraphPresentationDetails;
    maxPathLengthOptions: MaxPathLengthOptionResult;
}

export function useGraphSettings({
    queryId,
    selectedPresentation,
    selectedPresentationDetails,
    maxPathLengthOptions
}: Props) {
    const [viewKind, setViewKind, clearViewKind] = useLsValue<GraphViewKind, [number, number], []>({
        changeEntityParams: [queryId, selectedPresentation.id],
        getKey: ([qId, pId]) => `${LS_PREFIX}.queryGraph.${qId}.presentation${pId}.viewType`,
        defaultValue: selectedPresentationDetails.viewKind,
        validateValue: (value) => Object.values(GraphViewKind).includes(value as GraphViewKind),
        rewriteKeyParams: []
    });

    const [maxPathLength, setMaxPathLength, clearMaxPathLength] = useLsValue<
        string,
        [number, number],
        []
    >({
        rewriteKeyParams: [],
        changeEntityParams: [queryId, selectedPresentation.id],
        getKey: ([qId, pId]) => `${LS_PREFIX}.queryGraph.${qId}.presentation${pId}.maxPathLength`,
        defaultValue: String(selectedPresentationDetails.maxPathLength),
        validateValue: (value) => {
            return !!maxPathLengthOptions[viewKind as GraphViewKind].find(
                (option) => option.pathLength === Number(value)
            );
        }
    });

    return {
        maxPathLength: Number(maxPathLength),
        setMaxPathLength,
        clearMaxPathLength,
        viewKind,
        setViewKind,
        clearViewKind
    };
}
